import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";

import { useNavigate } from "react-router-dom";

export const SidebarData = [
  
  {
    title: "Dashboard",
    path: "/services",
    icon: <FaIcons.FaChartBar />,
  },
  {
    title: "Send Link to Smartphone Customers",
    path: "/contact",
    icon: <FaIcons.FaMobileAlt />,
  },
  {
    title: "Send OTP to Non-Smartphone Customers",
    path: "/events",
    icon: <FaIcons.FaSms />,
  },

  {
    title: "Reports",
    path: "/reports",
    icon: <FaIcons.FaCopy />,
  },

  {
    title: "My Profile",
    path: "/about-us",
    icon: <FaIcons.FaUser />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    
    //uncomment it for the edit profile bar below the my profile
    // subNav: [
    //   {
    //     // title: "Edit Profile",
    //     // path: "/about-us/aim",
    //     // icon: <FaIcons.FaUserEdit />,
    //   },
    //   {
    //     title: "Change Password",
    //     path: "/about-us/vision",
    //     icon: <AiIcons.AiOutlineKey />,
    //   },
    // ],
  },
  {
    title: "Logout",
    path: "/support",
    icon: <IoIcons.IoIosLogOut />,
  },
];
